import { AxiosResponse } from "axios"
import { apiInstance } from "../base"
import { IChannel, ICreateMarketingCampaign, IListMarketingCampaignResults, IListParticipationsResult, IListPrizesResult, IMarketingCampaignStatistics, IMarketingCampaing } from "./types"

export const getCampaigns = (page: number, limit: number, search: string): Promise<AxiosResponse<IListMarketingCampaignResults>> => {
    return apiInstance.handler.get<IListMarketingCampaignResults>(`/randomizer/marketing-campaigns`, {
        params: {
            page,
            limit, 
            search
        }
    })
}

export const createCampaign = (data: ICreateMarketingCampaign): Promise<AxiosResponse<IMarketingCampaing>> => {
    return apiInstance.handler.post<IMarketingCampaing>(`/randomizer/marketing-campaigns`, data)
}

export const toggleCampaign = (id: string): Promise<AxiosResponse<void>> => {
    return apiInstance.handler.post<void>(`/randomizer/marketing-campaigns/${id}/toggle`)
}

export const getCampaign = (id: string): Promise<AxiosResponse<IMarketingCampaing>> => {
    return apiInstance.handler.get<IMarketingCampaing>(`/randomizer/marketing-campaigns/${id}`)
}

export const getChannels = (): Promise<AxiosResponse<IChannel[]>> => {
    return apiInstance.handler.get<IChannel[]>(`/randomizer/channels`)
}

export const getChannelVerificationToken = (): Promise<AxiosResponse<{ token: string }>> => {
    return apiInstance.handler.get<{ token: string }>(`/randomizer/channels/verification-token`)
}

export const getPrizes = (id: string, page: number, limit: number): Promise<AxiosResponse<IListPrizesResult>> => {
    return apiInstance.handler.get<IListPrizesResult>(`/randomizer/marketing-campaigns/${id}/prizes`, {
        params: {
            limit,
            page
        }
    })
}

export const getParticiptionsCount = (id: string): Promise<AxiosResponse<{ count: 0 }>> => {
    return apiInstance.handler.get<{ count: 0 }>(`/randomizer/marketing-campaigns/${id}/participations-count`)
}

export const getMarketingCampaignStatistics = (id: string): Promise<AxiosResponse<IMarketingCampaignStatistics[]>> => {
    return apiInstance.handler.get<IMarketingCampaignStatistics[]>(`/randomizer/marketing-campaigns/${id}/statistics`)
}

export const marketingCampaignAnnounce = (id: string, text: string, channelId: number): Promise<AxiosResponse<void>> => {
    return apiInstance.handler.post<void>(`/randomizer/marketing-campaigns/${id}/announce`, {
        text,
        chatId: channelId,
        parseMode: "HTML",
        buttonText: "Участвую"
    })
}

export const postResults = (id: string, channelId: number): Promise<AxiosResponse<void>> => {
    return apiInstance.handler.post<void>(`/randomizer/marketing-campaigns/${id}/post-results`, {
        chatId: channelId,
    })
}

export const getMarketingCampaignReport = (startDate: string, endDate: string): Promise<AxiosResponse<any>> => {
    return apiInstance.handler.get(`/randomizer/marketing-campaigns/report`, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/pdf',
        },
        params: {
            start_date: startDate,
            end_date: endDate
        }
    })
}


export const listParticipations = (id: string, page: number, limit: number): Promise<AxiosResponse<IListParticipationsResult>> => {
    return apiInstance.handler.get<IListParticipationsResult>(`/randomizer/marketing-campaigns/${id}/participations`, {
        params: {
            limit,
            page
        }
    })
}